export const SET_BACKEND_CONNECTION_STATE = 'SET_BACKEND_CONNECTION_STATE';

//#region IQala
export const IQALA_SET_TABLE_OPTION = 'iqala/SET_TABLE_OPTION';
export const IQALA_SET_TABLE_SEARCH = 'iqala/SET_TABLE_SEARCH';
export const IQALA_SET_TABLE_EXTANDED_FILTER = 'iqala/SET_TABLE_EXTANDED_FILTER';
//#endregion